import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const About = () => {
  const values = [
    {
      icon: "🌿",
      title: "Éco-responsable",
      description: "Utilisation de produits respectueux de l'environnement et de pratiques durables"
    },
    {
      icon: "⭐",
      title: "Excellence",
      description: "Engagement constant vers la qualité et la perfection dans chaque intervention"
    },
    {
      icon: "🤝",
      title: "Confiance",
      description: "Relations durables basées sur la transparence et le professionnalisme"
    },
    {
      icon: "⚡",
      title: "Réactivité",
      description: "Intervention rapide et adaptation à vos besoins spécifiques"
    }
  ];

  return (
    <div className="min-h-screen pt-20 bg-gray-50">
      <SEO
        title="À Propos | E-omi Services"
        description="E-omi Services, entreprise de nettoyage professionnelle en Île-de-France depuis 2021. Engagement qualité, éco-responsabilité et réactivité."
        path="/about"
      />
      {/* Hero Section */}
      <div className="bg-blue-600 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6">
            Notre Histoire
          </h1>
          <p className="text-lg sm:text-xl max-w-3xl mx-auto text-blue-100">
            E-omi Services, votre partenaire de confiance en solutions de nettoyage professionnel depuis 2021
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Notre Mission */}
        <div className="mb-16 text-center">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-6">
            Notre Mission
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Chez E-omi Services, nous nous engageons à fournir des services de nettoyage exceptionnels 
            qui dépassent les attentes de nos clients. Notre objectif est de créer des environnements 
            propres, sains et accueillants pour tous nos clients, qu'il s'agisse de restaurants, 
            d'hôtels, de bureaux ou de résidences.
          </p>
        </div>
        

        {/* Nos Valeurs */}
        <div className="mb-16">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-8 text-center">
            Nos Valeurs
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="bg-white p-6 rounded-xl shadow-lg text-center">
                <div className="text-4xl mb-4">{value.icon}</div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">{value.title}</h3>
                <p className="text-gray-600">{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Notre Équipe */}
        <div className="mb-16">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-6 text-center">
            Notre Équipe
          </h2>
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <p className="text-gray-600 text-lg text-center max-w-3xl mx-auto">
              Notre équipe est composée de professionnels qualifiés et passionnés, 
              formés aux dernières techniques de nettoyage et équipés des meilleurs 
              outils. Chaque membre de notre équipe partage notre engagement envers 
              l'excellence et la satisfaction client.
            </p>
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center bg-blue-50 p-8 rounded-xl">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">
            Prêt à travailler avec nous ?
          </h2>
          <p className="text-gray-600 mb-8">
            Découvrez la différence d'un service professionnel et attentionné
          </p>
          <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-4">
            <Link to="/contact" className="btn-primary">
              Contactez-nous
            </Link>
            <Link to="/services" className="text-blue-600 font-semibold hover:text-blue-700 transition-colors duration-300">
              Voir nos services →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 